import { render, staticRenderFns } from "./ThousandText.vue?vue&type=template&id=092d5bee&scoped=true&"
import script from "./ThousandText.vue?vue&type=script&lang=ts&"
export * from "./ThousandText.vue?vue&type=script&lang=ts&"
import style0 from "./ThousandText.vue?vue&type=style&index=0&id=092d5bee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092d5bee",
  null
  
)

export default component.exports